// extracted by mini-css-extract-plugin
export default {"container":"TitleWithIcon_container__8N4Cg","title":"TitleWithIcon_title__-0NC4","darken":"TitleWithIcon_darken__SbCxJ"};